var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.4492,
    y: 15.3555,
    width: 20,
    height: 32,
    rx: 2,
    transform: "rotate(107 38.4492 15.3555)",
    stroke: "#00406B",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.3256,
    cy: 27.946,
    r: 2,
    transform: "rotate(107 28.3256 27.946)",
    stroke: "#00406B",
    strokeWidth: 1.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6316,
    cy: 25.8992,
    r: 2,
    transform: "rotate(107 21.6316 25.8992)",
    fill: "#07DF9E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.24337,
    cy: 21.8054,
    r: 2,
    transform: "rotate(107 8.24337 21.8054)",
    fill: "#07DF9E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9375,
    cy: 23.8523,
    r: 2,
    transform: "rotate(107 14.9375 23.8523)",
    stroke: "#00406B",
    strokeWidth: 1.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.2495,
    cy: 18.3826,
    r: 2,
    transform: "rotate(107 31.2495 18.3826)",
    stroke: "#00406B",
    strokeWidth: 1.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5554,
    cy: 16.3357,
    r: 2,
    transform: "rotate(107 24.5554 16.3357)",
    fill: "#07DF9E"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.167,
    cy: 12.2429,
    r: 2,
    transform: "rotate(107 11.167 12.2429)",
    fill: "#07DF9E"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.8613,
    cy: 14.2898,
    r: 2,
    transform: "rotate(107 17.8613 14.2898)",
    stroke: "#00406B",
    strokeWidth: 1.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 31.1186,
    y1: 23.2577,
    x2: 9.50612,
    y2: 16.6501,
    stroke: "#00406B",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedications);
export default __webpack_public_path__ + "static/media/medications.4efb6af3210da6014bb2321f733177f5.svg";
export { ForwardRef as ReactComponent };